import * as types from "../actionTypes";
import {CLOSE_PETTY_CASH_CONFIRM_DATA, SET_PETTY_CASH_CONFIRM_DATA} from "../actionTypes";

export const reasonModalData = data => {
  return {
    type: types.SET_REASON_PAGE_MODAL_DATA,
    data
  };
};
export const reasonCloseModal = () => {
  return {
    type: types.CLOSE_REASON_PAGE_MODAL_DATA
  };
};


export const confirmData = data => {
  return {
    type: types.SET_PETTY_CASH_CONFIRM_DATA,
    data
  };
};
export const closeConfirm = () => {
  return {
    type: types.CLOSE_PETTY_CASH_CONFIRM_DATA
  };
};

